import { cn } from '@april9au/react-common/utils';

import { filledStars } from '@/chat/scoring';
import { Icon } from '@/components/ui/icon';

const SLOTS = [1, 2, 3, 4, 5] as const;

/**
 * Five stars filled to `filledStars(score)` — the one star row in the app, so
 * a score fills the same number of stars wherever it is shown.
 *
 * Decorative: the caller states the score in text. Every star is the same
 * glyph with an outline, so it holds its edge on a pale card — filled in the
 * deeper action yellow, empty as a muted-ink outline. Sized by font size
 * (`text-xl` and so on), one `em` a star.
 */
export function Stars({ score, className }: { score: number; className?: string }) {
  const filled = filledStars(score);

  return (
    <span aria-hidden className={cn('inline-flex items-center gap-0.5', className)}>
      {SLOTS.map((star) => (
        <Icon
          key={star}
          name="passport/star"
          className={cn(
            // The glyph fills with `currentColor`; the stroke is ours.
            'size-[1em] overflow-visible [stroke-width:1.4] [stroke-linejoin:round]',
            star <= filled
              ? 'text-bp-yellow-hover stroke-bp-yellow-pressed'
              : 'stroke-bp-ink-muted/60 text-transparent',
          )}
        />
      ))}
    </span>
  );
}
